import { jsx as _jsx } from "react/jsx-runtime";
export default function Message(_ref) {
  var children = _ref.children,
    type = _ref.type;
  return _jsx("div", {
    className: "react-pdf__message react-pdf__message--".concat(type),
    children: children
  });
}